/* Galería en la tarjeta de producto de las categorías.
   Marcado: snippets/card-product.liquid · Estilos: card-galeria.css

   Todo va delegado en document, sin recorrer las tarjetas al cargar: la grilla
   de categorías se vuelve a dibujar entera cada vez que el cliente toca un
   filtro o cambia de página, y con listeners por tarjeta habría que volver a
   engancharlos en cada una de esas veces. */
(function () {
  'use strict';

  function pintar(galeria, n) {
    var puntos = galeria.querySelectorAll('.cardgal__punto');
    for (var i = 0; i < puntos.length; i++) {
      puntos[i].classList.toggle('esta', i === n);
    }
  }

  function indice(pista) {
    if (!pista.clientWidth) return 0;
    return Math.round(pista.scrollLeft / pista.clientWidth);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var boton = e.target.closest('.cardgal__flecha, .cardgal__punto');
    if (!boton) return;

    /* Sin esto el clic sigue viaje al enlace que cubre la tarjeta y se va a la
       ficha del producto, que es justo lo que la galería viene a evitar. */
    e.preventDefault();
    e.stopPropagation();

    var galeria = boton.closest('.cardgal');
    var pista = galeria && galeria.querySelector('.cardgal__fotos');
    if (!pista) return;

    var n;
    if (boton.classList.contains('cardgal__punto')) {
      n = Array.prototype.indexOf.call(boton.parentNode.children, boton);
    } else {
      n = indice(pista) + (boton.classList.contains('cardgal__flecha--der') ? 1 : -1);
    }
    n = Math.max(0, Math.min(pista.children.length - 1, n));

    pista.scrollTo({ left: n * pista.clientWidth, behavior: 'smooth' });
    /* Se marca al tiro y no esperando al evento de scroll: con el
       desplazamiento suave el punto tardaba en moverse y parecía trabado. */
    pintar(galeria, n);
  });

  /* El evento scroll no burbujea, así que se escucha en fase de captura. El
     temporizador se guarda en la propia pista: con uno solo compartido, dos
     galerías moviéndose a la vez se pisarían el aviso. */
  document.addEventListener(
    'scroll',
    function (e) {
      var pista = e.target;
      if (!pista.classList || !pista.classList.contains('cardgal__fotos')) return;
      clearTimeout(pista._cardgalTimer);
      pista._cardgalTimer = setTimeout(function () {
        pintar(pista.closest('.cardgal'), indice(pista));
      }, 60);
    },
    true
  );
})();
